import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { setCreateAndApproveSaleInvoiceToAccounting } from '../services/setCreateAndApproveSaleInvoiceToAccounting';


export const createAndApproveSaleInvoiceToAccounting = createAsyncThunk(
  'saleInvoices/createAndApproveSaleInvoiceToAccounting',
  async (params, { getState, dispatch }) => {
    console.log('params', params);
    const { saleInvoice } = params;

    const selectedProjectId = selectSelectedProjectId(getState());

    const response = await setCreateAndApproveSaleInvoiceToAccounting(selectedProjectId, saleInvoice);
    console.log('response', response);
    return response;
  }
);
